/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ThreadVariablesResponseVariables } from './threadVariablesResponseVariables';

/**
 * ``GET /inbox/threads/{thread_id}/variables`` response.
 *
 * A ``{key: value}`` map of every V1 template variable resolved
 * against the thread's live candidate / sender / job context. The
 * reply composer inserts these values as literal text (a manual
 * reply must never ship unresolved ``{{variable}}`` chips). Missing
 * data resolves to ``null``.
 */
export interface ThreadVariablesResponse {
  variables?: ThreadVariablesResponseVariables;
}
